import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'custom-loading',
  templateUrl: 'custom-loading.html'
})
export class CustomLoadingComponent implements OnInit {
  @Input() message = 'Explore the benefits of remote diagnostics';
  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/components/custom-loading/custom-loading.ts